/*
    Description: 请求配置
    Use: api内其他文件
*/
import axios, { AxiosRequestConfig } from 'axios'
import { ElMessage, ElLoading, ILoadingInstance } from 'element-plus'
import global from '@/utils/global'
import user from '@/utils/user'
import store from '../store'
import crypto from '@/utils/crypto'
import qs from 'qs'

const arr = ['/pay-module-export/salaried-detailed-by-process-ids', '/pay-module-export/processOrder/export', '/pay-module-export/statistics-info-all', '/pay-module-export/pay-stub/export', '/pay-module-export/pay-payment-record', '/pay-module-export/pay-personal-paid', '/pay-module-export/archived-export', '/ele-module-export/ele-sign-contract-record', '/insure-module-export/export-by-condition', '/insure-module-export/insure-info', '/pay-module-export/recharge-record', '/insure-module-export/list-insure-effective-user-export', '/insure-module-export/list-wesure-effective-user-export', '/pay-module-export/create-personnel-receipt', 'insure-module-export/period-recharge-list-export', '/pay-module-export/address-book/employee-list/export']
export const baseURL = process.env.VUE_APP_BASE_URL
let taskNum = 0
let loading: ILoadingInstance
// 初始化
const request = axios.create({
    baseURL,
    paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
    }
})
console.log(baseURL, 'baseURLbaseURL')

// 定义config数据类型
export interface RequestConfigDto extends AxiosRequestConfig {
    isLoading?: boolean
}

// 配置axios
request.interceptors.request.use(
    (config) => {
        // console.log(12345, config)
        // 仅匹配 arr数组里的 rul地址 这个是线上的
        if (config.baseURL === 'https://pro.51zidan.com/prod-api/') {
            arr.forEach((item: string) => {
                if (config.url?.split('?')[0] === item) {
                    config.baseURL = 'https://pro.51zidan.com/export-prod/'
                }
            })
        }
        // 仅匹配 arr数组里的 rul地址 这个是线上的
        if (config.baseURL === 'https://test.51zidan.com/testweb') {
            arr.forEach((item: string) => {
                if (config.url?.split('?')[0] === item) {
                    config.baseURL = 'https://test.51zidan.com/export-test'
                }
            })
        }
        //  仅匹配 arr数组里的 rul地址 这个是本地的
        // console.log(config.baseURL, 'config.baseURL', process.env.VUE_APP_BASE_URL_NEW, 'VUE_APP_BASE_URL_NEW')

        if (config.baseURL === process.env.VUE_APP_BASE_URL) {
            if (config.url?.split('---')[0] === '/isNew') {
                config.url = config.url?.split('---')[1]
                // config.baseURL = 'http://192.168.110.188:7010'
                config.baseURL = process.env.VUE_APP_BASE_URL_NEW // 'http://192.168.110.120:7010'
            }
            arr.forEach((item: string) => {
                if (config.url?.split('?')[0] === item) {
                    console.log('匹配到导出接口:', item, '切换baseURL到:', process.env.VUE_APP_BASE_EXPORT_URL)
                    config.baseURL = process.env.VUE_APP_BASE_EXPORT_URL
                }
            })
        }
        config.headers = config.headers || {}
        if (global.token) {
            config.headers.Authorization = 'Bearer ' + global.token
        }
        if (!config.headers || !config.headers.loading) {
            taskNum += 1
            if (taskNum === 1) {
                loading = ElLoading.service({
                    fullscreen: true,
                    background: 'rgba(0, 0, 0, 0)'
                })
            }
        }

        if (config.headers.crypto === 'crypto') {
            const timestamp = Date.now().toString();
            console.log(1234, crypto);
            const nonce = crypto.generateNonce();
            // AES密钥与随机向量
            const aesKey = crypto.generateAESKey();
            const iv = crypto.generateIV();

            // 加密密钥
            const keyData = JSON.stringify({ key: aesKey, iv: iv });
            // console.log('原始密钥数据：', keyData);
            const encryptedAESKey = crypto.rsaEncrypt(keyData);
            // console.log('RSA加密后的密钥：', encryptedAESKey);

            // 验证RSA加密
            const decryptedKey = crypto.rsaDecrypt(encryptedAESKey);
            // console.log('RSA解密后的密钥：', decryptedKey);

            // 比较原始数据和解密后的数据
            const originalKeyData = JSON.parse(keyData);
            // console.log('解析后的原始密钥：', originalKeyData);

            // 直接比较对象，因为 decryptedKey 已经是对象了
            const isKeyValid = decryptedKey.key === originalKeyData.key && decryptedKey.iv === originalKeyData.iv;
            // console.log('RSA加密验证：', isKeyValid);

            // 加密请求体
            const originalData = config.data || {};
            // console.log('原始数据：', originalData);
            const encryptedData = crypto.aesEncrypt(originalData, aesKey, iv);
            // console.log('AES加密后的数据：', encryptedData);

            // 验证AES加密
            const decryptedData = crypto.aesDecrypt(encryptedData, aesKey, iv);
            // console.log('AES解密后的数据：', decryptedData);
            // console.log('AES加密验证：', JSON.stringify(decryptedData) === JSON.stringify(originalData));

            // 生成签名
            const signature = crypto.generateSignature(originalData, timestamp, nonce, aesKey);
            // console.log('生成的签名：', signature);

            // 验证签名
            const isValidSignature = crypto.verifySignature(decryptedData, timestamp, nonce, aesKey, signature);
            // console.log('签名验证：', isValidSignature);

            // 添加请求头
            config.headers['X-Encrypted-Key'] = encryptedAESKey as string;
            config.headers['X-Signature'] = signature;
            config.headers['X-Timestamp'] = timestamp;
            config.headers['X-Nonce'] = nonce;

            config.data = {
                data: encryptedData,
            };
        }

        return config
    },
    (error) => {
        console.error('请求错误：', error.response)
        return Promise.reject(error.response)
    }
)

// 路由响应拦截
// http response 拦截器
request.interceptors.response.use(
    (response) => {
        console.log(7888, response);
        if (response.config.headers && !response.config.headers.loading) {
            taskNum -= 1
            if (taskNum === 0) {
                loading.close()
            }
        }
        let data = {}
        // console.log('response', response)

        switch (response.data.code) {
            case 401:
                loading.close()
                ElMessage.error('您的登录状态已失效，请重新登录！')
                user.exit()
                return Promise.reject(response.data)
            case 404:
                loading.close()
                ElMessage.error('网络请求错误，请稍后重试或联系管理员！')
                return Promise.reject(response.data)
            case 409:
                loading.close()
                ElMessage.error('您的账号已在其他客户端登录，请核验后重试！')
                user.exit()
                return Promise.reject(response.data)
            case 200:
                // 有的接口需要所有的数据，需要根据msg判断，所以需要返回原始数据，所以加了这个判断条件，对应的接口headers加allResponse
                if (response.config.headers?.allResponse) {
                    return response.data
                }
                if (response.data.data) {
                    //   console.log('进入200')
                    data = response.data.data
                } else {
                    //   console.log('进入2001')
                    data = response.data
                }
                return data
            default:
                if (response.headers['content-type'] === 'application/octet-stream' || response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8') {
                    let filename = response.headers['download-filename'] ?? response.headers['content-disposition']
                    filename = filename.replace(/attachment;filename/, '')
                    store.commit('setBlobFileName', decodeURIComponent(filename))
                    // store.setFileName(decodeURIComponent(filename))
                    return response.data
                } else {
                    loading.close()
                    const msg = response.data.msg ?? '网络请求错误，请稍后重试或联系管理员！'
                    if (msg.includes('\r\n\r\n')) {
                        const msgList = msg.split('\r\n\r\n')
                        let html = ''
                        msgList.forEach((item: string, index: number) => {
                            if (index === msgList.length - 1) {
                                html += '<div>' + item + '</div>'
                            } else {
                                html += '<div style="margin-bottom: 20px">' + item + '</div>'
                            }
                        })
                        ElMessage({
                            message: html,
                            type: 'error',
                            dangerouslyUseHTMLString: true,
                            zIndex: 20000
                        })
                    } else {
                        ElMessage.error({
                            message: msg,
                            type: 'error',
                            zIndex: 20000
                        })
                    }
                    return Promise.reject(response.data)
                }
        }
    },
    (error) => {
        loading.close()
        const msg = error.response?.data?.message ?? '网络连接错误，请检查网络后重试！'
        if (typeof msg === 'string' && msg.includes('\r\n\r\n')) {
            const msgList = msg.split('\r\n\r\n')
            let html = ''
            msgList.forEach((item: string) => {
                html += '<div style="margin-bottom: 10px">' + item + '</div>'
            })
            ElMessage({
                message: html,
                type: 'error',
                dangerouslyUseHTMLString: true,
                zIndex: 20000
            })
        } else {
            ElMessage.error(msg)
        }
        return Promise.reject(error.response?.data ?? error) // 返回接口返回的错误信息
    }
)
export default request
